export default "__VITE_ASSET__CS9paIJj__"